"use strict";

var _taggedTemplateLiteral = require("/root/website/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.containerBase = void 0;

var _stylitas = require("@creditas/stylitas");

var maxWidthXs = "\n  @media (min-width: 320px) {\n    max-width: 280px;\n  }\n";
var maxWidthSm = "\n  @media (min-width: 360px) {\n    max-width: 312px;\n  }\n";
var maxWidthMd = "\n  @media (min-width: 1024px) {\n    max-width: 944px;\n  }\n";
var maxWidthLg = "\n  @media (min-width: 1366px) {\n    max-width: 1248px;\n  }\n";
var maxWidthXl = "\n  @media (min-width: 1920px) {\n    max-width: 1440px;\n  }\n";
var fixedWidth = "\n".concat(maxWidthXs, "\n").concat(maxWidthSm, "\n").concat(maxWidthMd, "\n").concat(maxWidthLg, "\n").concat(maxWidthXl, "\n");

var containerBase = function containerBase(_ref) {
  var maxWidth = _ref.maxWidth,
      fixed = _ref.fixed;
  return (0, _stylitas.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    width: 100%;\n    margin-left: auto;\n    margin-right: auto;\n    box-sizing: border-box;\n    padding-left: 16px;\n    padding-right: 16px;\n\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n  "])), fixed && fixedWidth, maxWidth === 'xs' && maxWidthXs, maxWidth === 'sm' && maxWidthSm, maxWidth === 'md' && maxWidthMd, maxWidth === 'lg' && maxWidthLg, maxWidth === 'xl' && maxWidthXl);
};

exports.containerBase = containerBase;